import { LoadingOverlay } from "../../Molecules/LoadingOverlay";
import { useCurrentEscalation } from "../../../hooks/useCurrentEscalation";
import { ClickToCallProvider } from "../../CRM/ContactPage/V2/ClickToCall";

import { Overview } from "./Overview";
import { EscalationTableSectionRoot } from "./EscalationTableSectionRoot";
import { EscalationHeading } from "./EscalationHeading";

export function EscalationPageRoot() {
  const { isLoading } = useCurrentEscalation();

  return (
    <ClickToCallProvider>
      <LoadingOverlay
        loading={ isLoading }
      >
        <div className={ `grid gap-4 grid-cols-1 lg:grid-cols-12 mb-24` }>
          <EscalationHeading
            className={ `lg:col-span-12` }
          />
          <div className={ `lg:col-span-8` }>
            <EscalationTableSectionRoot />
          </div>

          <div className={ `lg:col-span-4 space-y-4` }>
            <Overview />
          </div>

          <div className={ `lg:col-span-12` }>
          </div>
        </div>
      </LoadingOverlay>
    </ClickToCallProvider>
  );
}
